import { render, staticRenderFns } from "./VenuesPage.vue?vue&type=template&id=d137409c"
import script from "./VenuesPage.vue?vue&type=script&lang=js"
export * from "./VenuesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports